// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1unlK","col":"styles_col__2n1eW"};